import CORRECT_LOCATION_ORIGIN from '@/configs/correctLocationOrigin';
import getWindow from './getWindow';

const isCorrectOrigin = () =>
  !!(getWindow()?.location?.origin === CORRECT_LOCATION_ORIGIN);

export default isCorrectOrigin;
